import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_appointment.css";
import Select2 from "../Common/Select2";
import 'select2/dist/css/select2.css';
import $ from 'jquery';
import "../../Api/apiUrls";
import { API_URL } from "../../Api/apiUrls";

function Add_appointment({ onClose }) {
  const [modalAdd_appointmentIsOpen, setAdd_appointmentModalIsOpen] = useState("");
  const [isAddingappointment, setIsAddingappointment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [price, setPrice] = useState('');
  const [tickets, setTickets] = useState('');
  const [source, setSource] = useState('Manual');
  const [formErrors, setFormErrors] = useState({});
  const [selectedGiftCard, setSelectedGiftCard] = useState(null);
  const [giftCards, setGiftCards] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [selectedInstructor, setSelectedInstructor] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [workshops, setWorkshops] = useState([]);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [appointmentSlots, setAppointmentSlots] = useState([]);
  const [selectedAppointmentSlot, setSelectedAppointmentSlot] = useState(null);

  const closeAdd_appointment = () => {
    setAdd_appointmentModalIsOpen(false);
  };

  function reloadPage() {
    window.location.reload();
  }

  const handleNumericInput = (e, setter) => {
    const value = e.target.value;
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      setter(value);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!selectedCustomer) errors.customer = "Customer is required";
    if (!selectedInstructor) errors.instructor = "Instructor is required";
    if (!selectedWorkshop) errors.workshop = "Workshop is required";
    if (!selectedAppointmentSlot) errors.slot = "Appointment slot is required";
    if (!source) errors.source = "Source is required";
    
    if (!selectedGiftCard) {
      if (!price) errors.price = "Price is required";
      if (!tickets) errors.tickets = "Number of tickets is required";
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    fetch(`${API_URL}/gift_card/get-gift_card/?status=Active`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const options = data.data.GiftCard.map(card => ({
            id: card.id,
            text: `${card.card_code} (${card.amount}) - ${(card.name ? card.name : card.email) ? card.name ? card.name : card.email : ''}`,
            amount: card.amount
          }));
          setGiftCards(options);
        }
      })
      .catch(error => {
        console.error('Error fetching gift cards:', error);
      });

    fetch(`${API_URL}/user/get-instructor/`)
      .then(response => response.json())
      .then(data => {
        const options = data.data.users.map(user => ({
          id: user.id,
          text: user.name,
          image: `${API_URL}/${user.profile_image}`,
        }));
        setInstructors(options);
      })
      .catch(error => {
        console.error('Error fetching instructors:', error);
      });

    fetch(`${API_URL}/user/get-users/`)
      .then(response => response.json())
      .then(data => {
        const options = data.data.users.map(user => ({
          id: user.id,
          text: user.name ? user.name : user.email,
          image: `${API_URL}/${user.profile_image}`,
        }));
        setCustomers(options);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching customers:', error);
        setIsLoading(false);
      });
  }, []);

  const handleGiftCardChange = (giftCardId) => {
    setSelectedGiftCard(giftCardId);
    if (giftCardId) {
      const selectedCard = giftCards.find(card => card.id == giftCardId);
      if (selectedCard) {
        setPrice(selectedCard.amount.toString());
        setTickets('1');
      }
    } else {
      setPrice('');
      setTickets('');
    }
  };

  const handleInstructorChange = (instructorId) => {
    setSelectedInstructor(instructorId);
    fetchWorkshopsByInstructor(instructorId);
  };

  const formatOption = (state) => {
    if (!state.id) return state.text;
    const instructor = instructors.find(inst => inst.id == state.id);
    if (!instructor) return state.text;
    return $(
      `<span><img src="${instructor.image}" class="img-flag" style="width:20px; margin-right: 10px;" />${state.text}</span>`
    );
  };

  const formatOptionSelection = (state) => {
    if (!state.id) return state.text;
    const instructor = instructors.find(inst => inst.id == state.id);
    if (!instructor) return state.text;
    return $(
      `<span><img src="${instructor.image}" class="img-flag" style="width:20px; margin-right: 10px;" />${state.text}</span>`
    );
  };

  const formatOptionCustomer = (state) => {
    if (!state.id) return state.text;
    const customer = customers.find(inst => inst.id == state.id);
    if (!customer) return state.text;
    return $(
      `<span><img src="${customer.image}" class="img-flag" style="width:20px; margin-right: 10px;" />${state.text}</span>`
    );
  };

  const formatOptionSelectionCustomer = (state) => {
    if (!state.id) return state.text;
    const customer = customers.find(inst => inst.id == state.id);
    if (!customer) return state.text;
    return $(
      `<span><img src="${customer.image}" class="img-flag" style="width:20px; margin-right: 10px;" />${state.text}</span>`
    );
  };

  const fetchWorkshopsByInstructor = (instructorId) => {
    fetch(`${API_URL}/workshop/get-workshop_for_website_by_workshop_instructor_id/?workshop_instructor_id=${instructorId}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const workshopOptions = data.data.Workshop.map(workshop => ({
            id: workshop.id,
            text: workshop.name,
          }));
          setWorkshops(workshopOptions);
        } else {
          setWorkshops([]);
        }
      })
      .catch(error => {
        console.error('Error fetching workshops:', error);
        setWorkshops([]);
      });
  };

  const handleWorkshopChange = (e) => {
    const workshopId = e.target.value;
    setSelectedWorkshop(workshopId);
    fetchAppointmentSlotsByWorkshop(workshopId);
  };

  const fetchAppointmentSlotsByWorkshop = (workshopId) => {
    fetch(`${API_URL}/workshop_slot/get-workshop_slot_by_workshop_id/?WorkshopSlot_workshop_id=${workshopId}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          const slotOptions = data.data.WorkshopSlot.map(slot => ({
            id: slot.id,
            date: slot.date,
            startTime: slot.startTime,
            endTime: slot.endTime,
          }));
          setAppointmentSlots(slotOptions);
        } else {
          setAppointmentSlots([]);
        }
      })
      .catch(error => {
        console.error('Error fetching appointment slots:', error);
        setAppointmentSlots([]);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    const selectedWorkshopData = workshops.find(workshop => workshop.id == selectedWorkshop);
    const selectedSlotData = appointmentSlots.find(appointmentSlot => appointmentSlot.id == selectedAppointmentSlot);
    
    const formData = new FormData();
    formData.append('user', selectedCustomer);
    formData.append('workshopSlot', selectedAppointmentSlot);
    
    if (!selectedGiftCard) {
      formData.append('price', parseInt(price, 10));
      formData.append('numberOfTickets', parseInt(tickets, 10));
    } else {
      const selectedCard = giftCards.find(card => card.id == selectedGiftCard);
      formData.append('price', parseInt(selectedCard.amount, 10));
      formData.append('numberOfTickets', 1);
      formData.append('gift_card', selectedGiftCard);
    }
    
    formData.append('status', "Active");
    formData.append('type', "Workshop");
    formData.append('name', selectedWorkshopData ? selectedWorkshopData.text : "");
    formData.append('slot', selectedSlotData ? `${selectedSlotData.startTime} - ${selectedSlotData.endTime}` : "");
    formData.append('source', source);

    setIsAddingappointment(true);
    
    fetch(`${API_URL}/appointment/add-appointment_by_admin/`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        setIsAddingappointment(false);
        if (data.success) {
          alert('Appointment successfully created!');
          resetForm();
          reloadPage();
        } else {
          alert(data.message || 'Failed to create appointment.');
        }
      })
      .catch(error => {
        setIsAddingappointment(false);
        console.error('Error:', error);
        alert('An error occurred while creating the appointment.');
      });
  };

  const resetForm = () => {
    setSelectedCustomer(null);
    setSelectedInstructor(null);
    setSelectedWorkshop(null);
    setSelectedAppointmentSlot(null);
    setPrice('');
    setTickets('');
    setSource('Manual');
    setSelectedGiftCard(null);
    setFormErrors({});
  };

  return (
    <div>
      {modalAdd_appointmentIsOpen && (
        <add_appointment onClose={closeAdd_appointment} />
      )}
      <div className="popup-background">
        <div className="popup">
          <div
            className="modal-content"
            style={{
              width: "100%",
              height: "80%",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              className="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                className="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Appointment</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              className="modal-body"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              <form>
                <div className="form-group">
                  <label className="small mb-1" htmlFor="customerSelect">
                    Select Customer <span style={{ color: 'red', fontSize: '10px' }}>*</span>
                  </label>
                  {!isLoading ? (
                    <Select2
                      id="customerSelect"
                      data={customers}
                      value={selectedCustomer}
                      onChange={(e) => setSelectedCustomer(e.target.value)}
                      options={{
                        placeholder: 'Select a customer',
                        allowClear: true,
                        templateResult: formatOptionCustomer,
                        templateSelection: formatOptionSelectionCustomer,
                      }}
                      style={{ width: '100%' }}
                    />
                  ) : (
                    <p>Loading customers...</p>
                  )}
                  {formErrors.customer && <div className="text-danger small">{formErrors.customer}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="giftCardSelect">
                    Select Gift Card (optional)
                  </label>
                  <Select2
                    id="giftCardSelect"
                    data={giftCards}
                    value={selectedGiftCard}
                    onChange={(e) => handleGiftCardChange(e.target.value)}
                    options={{
                      placeholder: 'Select a gift card (optional)',
                      allowClear: true,
                    }}
                    style={{ width: '100%' }}
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="instructorSelect">
                    Select Instructor <span style={{ color: 'red', fontSize: '10px' }}>*</span>
                  </label>
                  {!isLoading ? (
                    <Select2
                      id="instructorSelect"
                      data={instructors}
                      value={selectedInstructor}
                      onChange={(e) => handleInstructorChange(e.target.value)}
                      options={{
                        placeholder: 'Select an instructor',
                        allowClear: true,
                        templateResult: formatOption,
                        templateSelection: formatOptionSelection,
                      }}
                      style={{ width: '100%' }}
                    />
                  ) : (
                    <p>Loading instructors...</p>
                  )}
                  {formErrors.instructor && <div className="text-danger small">{formErrors.instructor}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="workshopSelect">
                    Select Workshop <span style={{ color: 'red', fontSize: '10px' }}>*</span>
                  </label>
                  <Select2
                    id="workshopSelect"
                    data={workshops}
                    value={selectedWorkshop}
                    onChange={handleWorkshopChange}
                    options={{
                      placeholder: 'Select a workshop',
                      allowClear: true,
                    }}
                    style={{ width: '100%' }}
                  />
                  {formErrors.workshop && <div className="text-danger small">{formErrors.workshop}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="appointmentSelect">
                    Select Appointment Slot/Date <span style={{ color: 'red', fontSize: '10px' }}>*</span>
                  </label>
                  <Select2
                    id="appointmentSelect"
                    data={appointmentSlots.map(slot => {
                      const formattedDate = new Date(slot.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      });
                      const startTime = new Date(`1970-01-01T${slot.startTime}`).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                      });
                      const endTime = new Date(`1970-01-01T${slot.endTime}`).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                      });
                      return {
                        id: slot.id,
                        text: `${formattedDate} | ${startTime} - ${endTime}`,
                      };
                    })}
                    value={selectedAppointmentSlot}
                    onChange={(e) => setSelectedAppointmentSlot(e.target.value)}
                    options={{
                      placeholder: 'Select an appointment slot',
                      allowClear: true,
                    }}
                    style={{ width: '100%' }}
                  />
                  {formErrors.slot && <div className="text-danger small">{formErrors.slot}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputSource">
                    Source <span style={{ color: 'red', fontSize: '10px' }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    id="inputSource"
                    type="text"
                    placeholder="Enter source"
                    value={source}
                    onChange={(e) => setSource(e.target.value)}
                  />
                  {formErrors.source && <div className="text-danger small">{formErrors.source}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputPrice">
                    Price {!selectedGiftCard && <span style={{ color: 'red', fontSize: '10px' }}>*</span>}
                  </label>
                  <input
                    className="form-control"
                    id="inputPrice"
                    type="text"
                    placeholder={selectedGiftCard ? "Automatically set from gift card" : "Enter Price"}
                    value={price}
                    onChange={(e) => handleNumericInput(e, setPrice)}
                    disabled={!!selectedGiftCard}
                  />
                  {formErrors.price && <div className="text-danger small">{formErrors.price}</div>}
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputTickets">
                    No. of Tickets {!selectedGiftCard && <span style={{ color: 'red', fontSize: '10px' }}>*</span>}
                  </label>
                  <input
                    className="form-control"
                    id="inputTickets"
                    type="text"
                    placeholder={selectedGiftCard ? "Automatically set to 1 for gift cards" : "Enter no. of tickets"}
                    value={tickets}
                    onChange={(e) => handleNumericInput(e, setTickets)}
                    disabled={!!selectedGiftCard}
                  />
                  {formErrors.tickets && <div className="text-danger small">{formErrors.tickets}</div>}
                </div>
              </form>
            </div>

            <div
              className="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                }}
              >
                Close
              </button>
              {isAddingappointment ? (
                <div>
                  <ThreeDots color="#000" height={50} width={50} />
                </div>
              ) : (
                <button
                  id="btnAdd"
                  type="button"
                  className="btn btn-primary"
                  style={{ background: "#000", border: "none" }}
                  onClick={handleSubmit}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_appointment;

